type Size = 'sm' | 'md' | 'lg'

interface BrandLockupProps {
  size?: Size
  className?: string
}

const SIZE_PX: Record<Size, number> = { sm: 13, md: 18, lg: 22 }

export default function BrandLockup({ size = 'md', className = '' }: BrandLockupProps) {
  return (
    <span
      className={className}
      style={{
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontWeight: 700,
        fontSize: SIZE_PX[size],
        letterSpacing: '-0.02em',
        lineHeight: 1,
        display: 'inline-flex',
        alignItems: 'baseline',
      }}
    >
      <span style={{ color: 'var(--bn-text-primary)' }}>better</span>
      <span style={{ color: 'var(--bn-text-subtle)', margin: '0 1px' }}>/</span>
      <span style={{ color: 'var(--bn-text-primary)' }}>notes</span>
    </span>
  )
}
